export default function concat(args) {
  return [].concat.apply([], args);
}